import { render, staticRenderFns } from "./MediaSummary.vue?vue&type=template&id=82117408&"
import script from "./MediaSummary.vue?vue&type=script&lang=js&"
export * from "./MediaSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports